import { useRetryMailOutboxItem } from "@/hooks/mutations/useRetryMailOutboxItem";

export function useMailOutboxPageActions() {
  const retryMutation = useRetryMailOutboxItem();

  return {
    retryingId: retryMutation.isPending ? retryMutation.variables : null,
    retryEmail: retryMutation.mutate,
  };
}
